import { Loading } from '@/components/lib/Loading'
import { OrderCreate } from '@/hooks/use-order-add'
import { ClientType } from '@/types/ClientType'
import { CompanyType } from '@/types/CompanyType'
import React from 'react'
import { Button, Card, Col, Form, Row } from 'react-bootstrap'
import { UseFormHandleSubmit, UseFormRegister, UseFormReset } from 'react-hook-form'

type Step1Type = {
  companies: CompanyType[]
  handleCompanySelected: (company: CompanyType) => void
}

export function Step1({ step1Props }: { step1Props: Step1Type }) {
  const { companies, handleCompanySelected } = step1Props
  return (
    <Row className='mt-4'>
      <Col xs={12} className='col-xl-8 col-lg-10 col-md-12 mx-auto py-3'>
        {companies.length == 0 ? (
          <Loading />
        ) : (
          <>
            <h6 className='text-center mb'>Sélectionnez la société</h6>
            <div className='text-center mb-4'>
              <small className='text-muted'>Etape 1 sur 4</small>
            </div>
            <Row xs={1} sm={2} md={3} lg={3} xl={4}>
              {companies?.map(
                (company: CompanyType) =>
                  company?.bookingSlots.length > 0 && (
                    <Col key={company?.id} className=''>
                      <Card
                        style={{ height: '120px' }}
                        className='my-3 py-2 pt-3 text-center cursor-pointer hover-box-shadow'
                        onClick={() => handleCompanySelected(company)}
                        key={company.id}
                      >
                        <Card.Body className='d-flex justify-content-center align-items-center'>
                          <>{company.name}</>
                        </Card.Body>
                      </Card>
                    </Col>
                  )
              )}
            </Row>
          </>
        )}
      </Col>
    </Row>
  )
}

type Step2Type = {
  isDesktop: boolean
  slotQtyDesktop: () => JSX.Element
  slotQtyMobile: () => JSX.Element
}

export function Step2({ step2Props }: { step2Props: Step2Type }) {
  const { isDesktop, slotQtyDesktop, slotQtyMobile } = step2Props

  return (
    <Row className='mt-4'>
      <Col className='col-xl-8 col-lg-10 col-md-12 mx-auto py-3'>
        <h6 className='text-center'>Réservez vos casiers</h6>
        <div className='text-center mb-4'>
          <small className='text-muted'>Etape 2 sur 4</small>
        </div>
        {isDesktop ? slotQtyDesktop() : slotQtyMobile()}
      </Col>
    </Row>
  )
}

type Step3Type = {
  handleSubmit: UseFormHandleSubmit<ClientType, undefined>
  handlePrepareOrder: (customer: ClientType) => void
  register: UseFormRegister<ClientType>
  reset: UseFormReset<ClientType>
  setOrders: React.Dispatch<React.SetStateAction<OrderCreate[]>>
  setStepCreation: React.Dispatch<React.SetStateAction<number>>
}

export function Step3({ step3Props }: { step3Props: Step3Type }) {
  const { handleSubmit, handlePrepareOrder, register, reset, setOrders, setStepCreation } =
    step3Props
  return (
    <Row className='mt-4'>
      <Col className='col-xl-6 col-lg-10 col-md-12 mx-auto py-3'>
        <h6 className='text-center'>Renseignez les coordonnées du destinaire</h6>
        <div className='text-center mb-4'>
          <small className='text-muted'>Etape 3 sur 4</small>
        </div>
        <Card>
          <Card.Body className='p-5'>
            <Form onSubmit={handleSubmit(handlePrepareOrder)}>
              <Form.Group as={Row} className='mb-3'>
                <Form.Label column sm={3}>
                  Nom <span className='text-danger'>*</span>
                </Form.Label>
                <Col sm={9}>
                  <Form.Control type='text' {...register('lastname', { required: true })} />
                </Col>
              </Form.Group>
              <Form.Group as={Row} className='mb-3'>
                <Form.Label column sm={3}>
                  Prénom <span className='text-danger'>*</span>
                </Form.Label>
                <Col sm={9}>
                  <Form.Control type='text' {...register('firstname', { required: true })} />
                </Col>
              </Form.Group>
              <Form.Group as={Row} className='mb-3'>
                <Form.Label column sm={3}>
                  N° Téléphone <span className='text-danger'>*</span>
                </Form.Label>
                <Col sm={9}>
                  <Form.Control type='text' {...register('phone', { required: true })} />
                </Col>
              </Form.Group>
              <Form.Group as={Row} className='mb-3'>
                <Form.Label column sm={3}>
                  Adresse email <span className='text-danger'>*</span>
                </Form.Label>
                <Col sm={9}>
                  <Form.Control type='text' {...register('email', { required: true })} />
                </Col>
              </Form.Group>
              <div className='buttons text-end mt-4'>
                <Button
                  variant='secondary'
                  className='me-3'
                  onClick={() => {
                    reset()
                    setOrders([])
                    setStepCreation(2)
                  }}
                >
                  Annuler
                </Button>
                <Button type='submit' variant='dark'>
                  Enregistrer
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

type Step4Type = {
  isDesktop: boolean
  productsOrderDesktop: () => JSX.Element
  productsOrderMobile: () => JSX.Element
}

export function Step4({ step4Props }: { step4Props: Step4Type }) {
  const { isDesktop, productsOrderDesktop, productsOrderMobile } = step4Props
  return (
    <>
      <Row className='mt-4'>
        <Col className='col-xl-8 col-lg-10 col-md-12 mx-auto py-3'>
          <h6 className='text-center'>Récapitulatif de la commande</h6>
          <div className='text-center mb-4'>
            <small className='text-muted'>Etape 4 sur 4</small>
          </div>
        </Col>
      </Row>
      {isDesktop ? productsOrderDesktop() : productsOrderMobile()}
    </>
  )
}